import React from "react";
import { LabelizeContainer, Label, RedText } from "./styles";

function Labelize({
  label,
  labelkey,
  mode,
  children,
  horizontal = false,
  isValid,
  applicationLabel,
  modalStyleLabel,
  isMeetingRequest,
  isAvailability,
  styleType,
}) {
  return (
    <LabelizeContainer
      horizontal={horizontal}
      isMeetingRequest={isMeetingRequest}
    >
      <Label
        styleType={styleType}
        horizontal={horizontal}
        applicationLabel={applicationLabel}
        modalStyleLabel={modalStyleLabel}
        isMeetingRequest={isMeetingRequest}
        isAvailability={isAvailability}
      >
        {label}
      </Label>
      {children}
    </LabelizeContainer>
  );
}
export default Labelize;
